var map = {
	"./AdvancedOptions.vue": 3219,
	"./Agenda.vue": 1933,
	"./Auth/ConfirmPassword.vue": 6027,
	"./Auth/ForgotPassword.vue": 5721,
	"./Auth/Login.vue": 9587,
	"./Auth/Register.vue": 97,
	"./Auth/ResetPassword.vue": 976,
	"./Auth/VerifyEmail.vue": 7836,
	"./Ayuda.vue": 6957,
	"./ClassRoom.vue": 9749,
	"./ClassRoomCard.vue": 4542,
	"./ClassRooms.vue": 2536,
	"./CollaboratorCard.vue": 6556,
	"./CollaboratorList.vue": 9739,
	"./CollaboratorRegistroAsistencia.vue": 8796,
	"./ComunicadoCard.vue": 2359,
	"./ComunicadoList.vue": 399,
	"./ConfigAsistencia.vue": 68,
	"./ConfigCatalogo.vue": 6838,
	"./ConfigClassRoom.vue": 3739,
	"./ConfigColegio.vue": 7285,
	"./ConfigCompany.vue": 9433,
	"./ConfigCourse.vue": 5608,
	"./ConfigCourseArea.vue": 2078,
	"./ConfigDistrito.vue": 8661,
	"./ConfigHelp.vue": 5077,
	"./ConfigLevel.vue": 1729,
	"./ConfigParentesco.vue": 7542,
	"./ConfigReligion.vue": 2018,
	"./ConfigTypeDoc.vue": 6952,
	"./Configuration.vue": 6604,
	"./CriterioEvaluacion.vue": 5614,
	"./Curricula.vue": 3584,
	"./Dashboard.vue": 6865,
	"./DiarioList.vue": 1916,
	"./DocumentForLevel.vue": 8240,
	"./Documents.vue": 9022,
	"./ExamenAdminsion.vue": 8043,
	"./FileCard.vue": 1381,
	"./FileList.vue": 4850,
	"./Financiera/Bank.vue": 5720,
	"./Financiera/Financiera.vue": 4023,
	"./Financiera/Order.vue": 4499,
	"./Financiera/Payment.vue": 291,
	"./FinancieraCard.vue": 1676,
	"./Freeday.vue": 3373,
	"./FreedayCard.vue": 289,
	"./ImportExcel.vue": 793,
	"./IndependentCourses/CourseStudent.vue": 5817,
	"./IndependentCourses/FichaCourse.vue": 3810,
	"./IndependentCourses/Index.vue": 7744,
	"./Offline.vue": 3316,
	"./Perfil.vue": 8214,
	"./Product.vue": 3386,
	"./ProductCard.vue": 3508,
	"./Report.vue": 4302,
	"./ReportAsistencia.vue": 9836,
	"./ReportCalification.vue": 5684,
	"./ReportCalificationMerito.vue": 4463,
	"./ReportIndependentCourse.vue": 3593,
	"./ReportRegistroAsistencia.vue": 2909,
	"./ReportStudent.vue": 3481,
	"./Roles.vue": 2925,
	"./Silabo.vue": 8381,
	"./Student.vue": 8840,
	"./StudentCard.vue": 8055,
	"./StudentCourseCard.vue": 5539,
	"./StudentCourses.vue": 7987,
	"./StudentEnrolled.vue": 8759,
	"./StudentForm.vue": 2181,
	"./StudentUploadSiagie.vue": 2035,
	"./TableAdvanced.vue": 6606,
	"./UserCard.vue": 6465,
	"./UserList.vue": 5939,
	"./Welcome.vue": 3248,
	"./rrhh/AsistenciaBalanceEmpleado.vue": 409,
	"./rrhh/AsistenciaBalanceEmpleados.vue": 3237,
	"./setup/ControlPanel.vue": 8588,
	"./setup/ControlPanelSuperAdmin.vue": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;